import * as ActionTypes from 'actions';
import Calendar from 'lib/Calendar';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  events: [],
  byId: {},
  isLoading: false,
  response: {},
  count: 0,
};

export default function(state = initialState, action = {}) {
  const { type, response, id, error, payload } = action;
  const { byId } = state;

  switch (type) {
  case ActionTypes.INBOX_SET_COUNT:
    return Object.assign({}, state, { count: payload.count });

  case ActionTypes.INBOX_REQUEST:
    return Object.assign({}, state, { events: [], isLoading: true });

  case ActionTypes.INBOX_SUCCESS: {
    const metadata = response.metadata ? response.metadata : {};
    const massagedEvents = response.tfs_Event.map((event) => {
      const massaged = Calendar.massageEvent(event, metadata);
      byId[event.id] = massaged;
      return massaged;
    });

    return Object.assign({}, state, { events: massagedEvents, byId, response, isLoading: false });
  }

  case ActionTypes.INBOX_FAILURE:
    console.error('Error loading requests', error);

    return Object.assign({}, state, { response, isLoading: false });


  case ActionTypes.INBOX_EVENT_REQUEST:
    byId[id] = byId[id] ? Object.assign({}, byId[id], { isLoading: true }) : { isLoading: true };

    return Object.assign({}, state, { byId });

  case ActionTypes.INBOX_EVENT_SUCCESS: {
    const event = response.tfs_Event.length ? response.tfs_Event[0] : {};
    const metadata = response.metadata ? response.metadata : {};

    byId[id] = Calendar.massageEvent(Object.assign(event, { isLoading: false }), metadata);

    return Object.assign({}, state, { byId });
  }

  case ActionTypes.INBOX_EVENT_FAILURE: {
    console.error('Error loading event', id, error);
    byId[id] = { isLoading: false };

    return Object.assign({}, state, { byId });
  }

  case ActionTypes.INBOX_MARK_CHANGE_APPROVED: {
    const { eventId, changeId, changeSetId } = payload;

    if (!byId[eventId]) {
      return state;
    }

    let removeIndex = false;
    byId[eventId].changes.forEach((change, index) => {
      if (change.change_id && change.change_id === changeId) {
        removeIndex = index;
      } else if (change.change_set_id && change.change_set_id === changeSetId) {
        removeIndex = index;
      }
    });

    if (removeIndex !== false) {
      const event = Object.assign({}, byId[eventId]);
      event.changes.splice(removeIndex, 1);
      byId[eventId] = event;

      return Object.assign({}, state, { byId });
    }

    return state;
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/inbox.js